// 261023 E3-P3ka (mockup Rev 3) — các mục «⋯» của bước ⑤. THUẦN, không antd/react: quyết định mục nào hiện / mờ / vì sao; `ScriptStage` + `EpisodeReader` chỉ nối hàm bấm.
// Trang tập: toolbar còn 3 nút (Sửa · ✦ Trợ lý · ⋯); Phiên bản / Viết lại / Chấm lại / Đẩy riêng / Người phụ vào «⋯». Nhóm DANH SÁCH (3k-c: hiện ở mọi trạng thái, không còn «Chọn tập…» vì ô tick ở cột trái). Không mục nào làm việc mới — chỉ là đường tới việc đã có.
export const EDITING_WHY = 'Đang sửa tay — Lưu hoặc Huỷ trước';

export interface ScriptMenuSpec { key: string; label: string; danger?: boolean; disabled?: boolean; reason?: string }

export interface EpisodeMenuCtx {
  ep: number;
  hasScript: boolean;
  versionCount: number;
  editing: boolean;
  locked: boolean;
  /** Viết lại không dùng được (bận / khoá / chuỗi đoạn nguồn chặn / đang sửa) — tính ở `EpisodeReader` (`writeOff`). */
  writeOff: boolean;
  writeBlockedText: string | null;
  rejudge: { show: boolean; disabled: boolean; running: boolean; tip?: string };
  push: { pushable: boolean; pushed: boolean; busy: boolean; reason: string | null };
  /** Số tập chưa có người phụ; null/0 ⇒ nhãn không kèm số. */
  extrasMissing: number | null;
}

const withReason = (s: ScriptMenuSpec, disabled: boolean, reason?: string | null): ScriptMenuSpec => (disabled ? { ...s, disabled: true, ...(reason ? { reason } : {}) } : s);

export const episodeMenuOf = (c: EpisodeMenuCtx): ScriptMenuSpec[] => {
  const out: ScriptMenuSpec[] = [];
  if (c.hasScript) {
    out.push(withReason({ key: 'rewrite', label: 'Viết lại tập', danger: true }, c.writeOff, c.editing ? EDITING_WHY : c.writeBlockedText));
    out.push(withReason({ key: 'versions', label: `Phiên bản (${c.versionCount})` }, c.locked || c.editing, c.editing ? EDITING_WHY : c.locked ? 'Bước đang khoá' : null));
    if (c.rejudge.show) out.push(withReason({ key: 'rejudge', label: 'Chấm lại bằng AI' }, c.rejudge.disabled || c.rejudge.running || c.editing, c.editing ? EDITING_WHY : c.rejudge.running ? 'Đang chấm lại' : c.rejudge.tip));
  }
  const p = c.push;
  const pushReason = c.editing ? EDITING_WHY : p.pushed ? 'Chapters đang khớp bản này' : !p.pushable ? (p.reason || 'Tập này chưa đủ điều kiện đẩy — xem lý do ở dòng «Cần xem»') : p.busy ? 'Đang đẩy hoặc có việc nền khác' : null;
  out.push(withReason({ key: 'pushOne', label: 'Đẩy riêng tập này sang Chapters' }, !!pushReason, pushReason));
  if (c.hasScript) out.push({ key: 'extras', label: typeof c.extrasMissing === 'number' && c.extrasMissing > 0 ? `Người phụ không tên (${c.extrasMissing})` : 'Người phụ không tên' });
  return out;
};

export interface ListMenuCtx {
  /** Số tập chưa có kịch bản DRAFT. */
  missing: number;
  locked: boolean;
  /** Có việc chạy nền / đang viết. */
  busy: boolean;
  /** Dàn tập chưa chốt / cũ — chặn tạo kịch bản mới. */
  planBlocked: boolean;
  scriptCount: number;
  readerReady: boolean;
  pushAvailable: boolean;
}

export const listMenuOf = (c: ListMenuCtx): ScriptMenuSpec[] => {
  const out: ScriptMenuSpec[] = [];
  if (c.missing > 0) {
    out.push(withReason({ key: 'writeMissing', label: `Viết ${c.missing} tập chưa viết` }, c.busy || c.locked || c.planBlocked,
      c.locked ? 'Bước đang khoá' : c.planBlocked ? 'Dàn tập chưa chốt — chốt dàn tập ở bước ④ trước' : c.busy ? 'Đang có việc chạy nền — đợi xong' : null));
  }
  if (c.pushAvailable) out.push(withReason({ key: 'pushAll', label: 'Đẩy sang Chapters…' }, c.busy || c.scriptCount === 0, c.scriptCount === 0 ? 'Chưa có kịch bản nào để đẩy' : 'Đang có việc chạy nền — đợi xong'));
  out.push(withReason({ key: 'reader', label: 'AI đọc cả mùa…' }, !c.readerReady, 'Chưa có kết quả AI đọc cả mùa'));
  return out;
};
